import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CalendarClockIcon } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AnalysisDataExtractionJobs } from './AnalysisDataExtractionJobs';
import { StoreSkuSalesDatesForm } from './StoreSkuSalesDatesForm';
import type { SimpleAccount } from '@/lib/types';

interface StoreSkuSalesDatesExtractionProps {
  account: SimpleAccount;
}

/**
 * 店舗×SKU 初回/最終販売日・初回入庫日タブのコンテンツ（FKV3-12941 / 初回入庫日は FKV3-13065）
 * 抽出条件・実行ログをサブタブで切り替える（他メニューと同じ構成）
 */
export function StoreSkuSalesDatesExtraction({ account }: StoreSkuSalesDatesExtractionProps) {
  const [activeTab, setActiveTab] = useState('form');

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
        <CalendarClockIcon size={24} style={{ marginRight: 8 }} />
        店舗×SKU 初回/最終販売日・初回入庫日
      </Typography>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="form">抽出条件</TabsTrigger>
          <TabsTrigger value="logs">実行ログ</TabsTrigger>
        </TabsList>

        <TabsContent value="form" className="mt-6">
          <StoreSkuSalesDatesForm account={account} onSubmitted={() => setActiveTab('logs')} />
        </TabsContent>

        <TabsContent value="logs" className="mt-6">
          <AnalysisDataExtractionJobs account={account} menuType="store_sku_sales_dates" />
        </TabsContent>
      </Tabs>
    </Box>
  );
}
